import { render, staticRenderFns } from "./ImagePicker.vue?vue&type=template&id=afc359f0&scoped=true"
import script from "./ImagePicker.vue?vue&type=script&lang=js"
export * from "./ImagePicker.vue?vue&type=script&lang=js"
import style0 from "./ImagePicker.vue?vue&type=style&index=0&id=afc359f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc359f0",
  null
  
)

export default component.exports